import { render } from "./healthScoreList.vue?vue&type=template&id=ae284960&scoped=true"
import script from "./healthScoreList.vue?vue&type=script&lang=js"
export * from "./healthScoreList.vue?vue&type=script&lang=js"

import "./healthScoreList.vue?vue&type=style&index=0&id=ae284960&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae284960"]])

export default __exports__